import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { AccordionDetails, AccordionSummary, Box } from '@material-ui/core';
import React, { FC } from 'react';
import { useShopConfig } from '../../hooks/shopConfig';
import { StyledAccordion, TypographyWrapper } from '..';
import { FAQ } from '../../types/shopConfig/shopConfigV2';
import { ShipDeadline } from '../../util/shipping';
import { FAQDescription, FAQTitle } from './components/FAQComponents';
import {
  BuyerAdditionalFAQAccordionSections,
  PaymentFAQAccordionSection,
  RefundPolicyFAQAccordionSection,
  ShippingLengthFAQAccordionSection,
} from './accordionSections';

const BuyerFAQ: FC = () => {
  // TODO (SY|TREET-1066): Once all fields are moved to
  // contentful, refactor this to use shopconfigV2
  const {
    treetShopName,
    copy: { buyerAdditionalFaq, faqCopy },
  } = useShopConfig();

  return (
    <>
      <StyledAccordion name="why-shop">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <h4>
            <FAQTitle>{faqCopy[FAQ.WhyShop]?.title || 'Why should I shop here?'}</FAQTitle>
          </h4>
        </AccordionSummary>
        <AccordionDetails>
          <span>
            {faqCopy[FAQ.WhyShop] ? (
              <FAQDescription>{faqCopy[FAQ.WhyShop].description}</FAQDescription>
            ) : (
              <>
                <TypographyWrapper variant="body1">
                  {treetShopName} is the dedicated site for buying and selling our products
                  secondhand. We’ve created this space for you to have the best shopping experience
                  for finding and purchasing our secondhand items.
                </TypographyWrapper>
                <Box mt={1}>
                  <TypographyWrapper variant="body1">
                    All posts are reviewed prior to going live and your purchases are backed by
                    Treet Protection so you’re guaranteed to receive the product that was promised.
                  </TypographyWrapper>
                </Box>
              </>
            )}
          </span>
        </AccordionDetails>
      </StyledAccordion>
      <ShippingLengthFAQAccordionSection />
      <StyledAccordion name="missed-shipping-deadline">
        <AccordionSummary
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel3a-content"
          id="panel3a-header"
        >
          <h4>
            <FAQTitle>
              {faqCopy[FAQ.WhatIfItemDoesntShip]?.title ||
                `What happens if my item doesn’t ship after ${ShipDeadline.Default} business days?`}
            </FAQTitle>
          </h4>
        </AccordionSummary>
        <AccordionDetails>
          <TypographyWrapper variant="body1">
            {faqCopy[FAQ.WhatIfItemDoesntShip]?.description || (
              <>
                On the rare occasion where your order doesn’t ship within the {ShipDeadline.Default}
                -day shipping window, we will automatically cancel the order and refund your
                purchase.
              </>
            )}
          </TypographyWrapper>
        </AccordionDetails>
      </StyledAccordion>
      <PaymentFAQAccordionSection />
      <RefundPolicyFAQAccordionSection />
      {buyerAdditionalFaq && <BuyerAdditionalFAQAccordionSections />}
    </>
  );
};
export default BuyerFAQ;
